import { Dialog } from '@ori-ui/components';
import { ArrowLeftThin } from '@ori-ui/icons';
import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useState } from 'react';

import { ChangeConsultantForm } from './ChangeConsultantForm';
import { ORDER_ON_BEHALF_DIALOG, ORDER_ON_BEHALF_DIALOG_BACK_ARROW } from './constants';
import { BackArrow, PopupButton, PopupContentGroup, PopupLink } from './styles';
import type { OrderOnBehalfDialogProps } from './types';

export const OrderOnBehalfDialog = (props: OrderOnBehalfDialogProps) => {
  const { vipAccessData, vipAccessLabels, open, close } = props;
  const [changeOpened, setChangeOpened] = useState(false);
  const { getTestId } = useTestId();

  return (
    <Dialog
      data-testid={getTestId(ORDER_ON_BEHALF_DIALOG)}
      header={
        changeOpened ? (
          <>
            <BackArrow
              data-testid={getTestId(ORDER_ON_BEHALF_DIALOG_BACK_ARROW)}
              onClick={() => setChangeOpened(false)}
            >
              <ArrowLeftThin />
            </BackArrow>
            <Typography variant="h5">{vipAccessLabels.ConsultantChangeConsultantNumber}</Typography>
          </>
        ) : undefined
      }
      open={open}
      hideCloseButton={changeOpened}
      onClose={() => close()}
    >
      <PopupContentGroup>
        {changeOpened ? (
          <ChangeConsultantForm vipAccessLabels={vipAccessLabels} />
        ) : (
          <>
            <PopupButton
              fullWidth
              variant="contained"
              color="primary"
              href={vipAccessData.Links[0]?.Url}
            >
              {vipAccessData.Links[0]?.Text}
            </PopupButton>
            <PopupButton
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => setChangeOpened(true)}
            >
              {vipAccessLabels.ConsultantChangeConsultantNumber}
            </PopupButton>
            <PopupLink
              variant="button"
              color="primary"
              href={vipAccessData.Links[2]?.Url}
            >
              {vipAccessData.Links[2]?.Text}
            </PopupLink>
          </>
        )}
      </PopupContentGroup>
    </Dialog>
  );
};
